export const NumericValueTypes = {
    DECIMAL: "decimal",
    CURRENCY: "currency",
};